import {getPid} from "@/common/api";
export const PidInfo = {
  data() {
    return {
      pidInfo: {}
    }
  },
  methods: {
    // 获取pid信息
    getPidInfo(userInfo) {
      const req = {
        userId: userInfo.userId,
        userType: userInfo.userType
      }
      return getPid(req).then(res => {
        if (res.data.code==200 && res.data.data) {
          this.pidInfo = res.data.data
        }
      })
    },
    usePid(classType) {
      let classTypeCase = classType.toString()
      switch (classTypeCase) {
        case '1':
          return this.pidInfo.pddPid;
        case '2':
          return this.pidInfo.jdPid;
        case '3':
          return this.pidInfo.tbPid;
        case '6':
          return this.pidInfo.snPid;
        case '7':
          return this.pidInfo.wphPid;
        case '9':
          return this.pidInfo.klPid;
        case '12':
          return this.pidInfo.miPid;
        case '16':
          return this.pidInfo.ksPid;
        case '17':
          return this.pidInfo.txPid;
        case '18':
          return this.pidInfo.xjPid;
        case '19':
          return this.pidInfo.dyPid;
        default:
          return ''
      }
    }
  }
}
